module.exports = __webpack_public_path__ + "static/media/sadag-avatar.19c4f613.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sadag-avatar.png
// module id = 799
// module chunks = 2